import Detail from './Detail'
// import Form from './Form'

export default {
  Detail,
  // Form
}